export enum MechanicAssignmentMode {
  RECEIVING_PERSON = "RECEIVING_PERSON",
  NONE = "NONE",
}
